import { BedDouble, PlaneTakeoff, Wallet, Globe2 } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const points = [
  { icon: BedDouble, title: "On-Site Accommodation", text: "We have our own accommodation on site — reducing your transport costs to zero and putting you minutes from the aircraft." },
  { icon: PlaneTakeoff, title: "Live at the Airport", text: "Wake up, walk to the hangar, fly. Nothing between you and your training but a short stroll across the apron." },
  { icon: Wallet, title: "Affordable Living", text: "South Africa's low cost of living stretches your budget further, so more of it goes into your logbook." },
  { icon: Globe2, title: "Help If We're Full", text: "If our accommodation is fully booked, we help you find a close-by option that suits your needs." },
];

export const Accommodation = () => (
  <section id="accommodation" className="py-24 lg:py-32 bg-white" data-testid="accommodation">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <Reveal><Overline>Accommodation</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)]">Stay where you <span className="italic text-accent">train</span>.</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-5 text-[var(--muted)] text-base md:text-lg leading-relaxed">One of the few academies with its own serviced accommodation on site. Living at the airport means zero commute, more flying time and a focused, driven cohort of fellow students around you.</p></Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {points.map((p) => (
                <div key={p.title} className="rounded-2xl border border-[var(--line)] p-6 card-shadow">
                  <div className="h-11 w-11 rounded-xl bg-navy flex items-center justify-center"><p.icon size={20} className="text-accent-2" /></div>
                  <h3 className="mt-4 font-display font-semibold text-[var(--primary)]">{p.title}</h3>
                  <p className="mt-2 text-sm text-[var(--muted)] leading-relaxed">{p.text}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.1}>
            <div className="relative rounded-2xl overflow-hidden card-shadow-lg aspect-[4/5]">
              <img src="/img/accommodation.webp" alt="On-site serviced student accommodation" loading="lazy" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f3159]/60 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
